import { Component, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { AuthService } from '@teem/app/core/services/auth.service';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
declare var $;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;
  otpForm: FormGroup;
  step: number = 1;
  resendTimer: number = 0;
  resendDisabled: boolean = true;
  interval: any;
  showPassword = {
    password: false,
    confirmPassword: false
  };

  private clickListener: () => void;

  constructor(
    private fb: FormBuilder, 
    private renderer: Renderer2, 
    private loaderService: LoaderService,
    private authService: AuthService,
    private router: Router,
  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      passwordConfirm: ['', [Validators.required]]
    }, { validators: this.passwordMatchValidator });

    this.otpForm = this.fb.group({
      0: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      1: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      2: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      3: ['', [Validators.required, Validators.pattern(/^\d$/)]],
    });
  }

  ngOnInit(): void {
  }

  passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.get('password')?.value;
    const confirmPassword = control.get('passwordConfirm')?.value;
    if (password && confirmPassword && password !== confirmPassword) {
      control.get('passwordConfirm')?.setErrors({ mismatch: true });
      return { mismatch: true };
    }
    return null;
  }

  ngAfterViewInit(): void {
    this.updateLeftStepHeight();

    const signupStepsRight = document.querySelector('.signup_steps_right') as HTMLElement;

    if (signupStepsRight) {
      this.clickListener = this.renderer.listen(signupStepsRight, 'click', () => {
        this.updateLeftStepHeight();
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['step']) {
      this.updateLeftStepHeight();
    }
  }

  private updateLeftStepHeight(): void {
    const signupStepsRight = document.querySelector('.signup_steps_right') as HTMLElement;
    const signupStepsLeft = document.querySelectorAll('.signup_steps_left');

    if (signupStepsRight) {
      const rightHeight = signupStepsRight.clientHeight;
      signupStepsLeft.forEach((leftStep) => {
        this.renderer.setStyle(leftStep, 'height', `${rightHeight + 60}px`);
      });
    }
  }

  isFormValid(): boolean {
    if (this.step == 1) {
      return this.forgotPasswordForm.get('email')?.valid;
    } else {
      return this.forgotPasswordForm.get('password')?.valid && this.forgotPasswordForm.get('passwordConfirm')?.valid;
    }
    
  }

  nextStep(): void {
    if (this.step == 1) {
      let fd;
      fd = {
        username: this.forgotPasswordForm.get('email')?.value
      };

      this.loaderService.startLoading();  
      this.authService.sendForgotOtp(fd).subscribe((res: any) => {
        this.loaderService.stopLoading();
        this.step++;
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), "error");
      });
    }
    // else if (this.step === 2) {
    //   this.resendTimer = 0;      
    //   const otp = Object.values(this.otpForm.value).join('');
    //   let fd;
    //   fd = { username: this.forgotPasswordForm.get('email')?.value, otp: otp };
    //   this.loaderService.startLoading();
    //   // setTimeout(() => {
    //   //   this.step++;
    //   //   this.loaderService.stopLoading();
    //   // }, 1000)
    //   this.authService.verifyForgot(fd).subscribe((res: any) => {
    //     this.loaderService.stopLoading();
    //     this.step++;
    //   }, err => {
    //     this.loaderService.stopLoading();
    //     Swal.fire(i18n.alert.error, i18n.getError(err), "error");
    //   });
    // }
  }

  verifyOTP(): void {
    this.resendTimer = 0;      
    const otp = Object.values(this.otpForm.value).join('');
    let fd;
    fd = { username: this.forgotPasswordForm.get('email')?.value, otp: otp };
    this.loaderService.startLoading();
    // setTimeout(() => {
    //   this.step++;
    //   this.loaderService.stopLoading();
    // }, 1000)
    this.authService.verifyForgot(fd).subscribe((res: any) => {
      this.loaderService.stopLoading();
      this.step++;
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), "error");
    });
  }

  get otpControls(): FormControl[] {
    return Object.keys(this.otpForm.controls).map(
      key => this.otpForm.get(key) as FormControl
    );
  }

  focusNext(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    if (input.value && index < this.otpControls.length - 1) {
      const nextInput = document.querySelectorAll<HTMLInputElement>('.otp-input')[index + 1];
      nextInput?.focus();
    }
  }

  startResendTimer(): void {
    this.resendDisabled = true;
    this.resendTimer = 30;
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(() => {
      if (this.resendTimer > 0) {
        this.resendTimer--;
      } else {
        this.resendDisabled = false;
        clearInterval(this.interval);
      }
    }, 1000);
  }

  resendOTP(): void {
    this.startResendTimer();
    let fd;
    fd = { username: this.forgotPasswordForm.get('email')?.value };
    this.loaderService.startLoading();  
    this.authService.resendOtp(fd).subscribe((res: any) => {
      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), "error");
    });
  }

  togglePasswordVisibility(field: 'password' | 'confirmPassword'): void {
    this.showPassword[field] = !this.showPassword[field];
  }

  onSubmit(): void {
    if (this.isFormValid()) {
      this.loaderService.startLoading();
      const loginData = {
        username: this.forgotPasswordForm.get('email')?.value,
        password: this.forgotPasswordForm.get('password')?.value,
        password_confirmation: this.forgotPasswordForm.get('passwordConfirm')?.value,
      };

      this.authService.setPassword(loginData).subscribe({
        next: (res) => {
          this.loaderService.stopLoading();
          this.router.navigate(['/login']);
        },
        error: (err) => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        },
      });
    }
  }
}
